"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDocumentTitleByFilter = exports.getStateFromParams = exports.getBirthNumberFor = exports.getStartingLettersForFilter = exports.getBirthDate = exports.sentenseCase = void 0;
const dayjs_1 = __importDefault(require("dayjs"));
const timezone_1 = __importDefault(require("dayjs/plugin/timezone"));
const utc_1 = __importDefault(require("dayjs/plugin/utc"));
const astro_1 = require("../astro");
const numerology_1 = require("../numerology");
const timezones_1 = require("../timezones");
// Extended here rather than only in the entry points, since the astro helpers
// below are shared by the browser bundle and the server bundle.
dayjs_1.default.extend(utc_1.default);
dayjs_1.default.extend(timezone_1.default);
const sentenseCase = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
exports.sentenseCase = sentenseCase;
/**
 * Birth date as an absolute instant. `tob` is a wall-clock value, so it only
 * identifies a moment once it is read in the selected timezone.
 */
const getBirthDate = (tob, tz) => {
    if (!tob || !tz) {
        return null;
    }
    try {
        const date = dayjs_1.default.tz(tob, tz);
        return date.isValid() ? date.toDate() : null;
    }
    catch {
        // dayjs.tz throws on an unknown timezone name.
        return null;
    }
};
exports.getBirthDate = getBirthDate;
const getStartingLettersForFilter = (filter) => {
    if (filter.startsWithMode === 'manual') {
        return filter.startsWith;
    }
    if (filter.startsWithMode === 'auto') {
        const date = (0, exports.getBirthDate)(filter.tob, filter.tz);
        if (date) {
            const lunarMansionIndex = (0, astro_1.getLunarMansionIndex)(date, filter.panjangam);
            return [
                ...(0, astro_1.getStartingLettersForName)(lunarMansionIndex, 'en'),
                ...(0, astro_1.getStartingLettersForName)(lunarMansionIndex, 'ta'),
            ];
        }
    }
    return undefined;
};
exports.getStartingLettersForFilter = getStartingLettersForFilter;
/**
 * The day of the month has to be read in the timezone of birth, not wherever
 * the server runs. Only auto mode asks for a date of birth; anywhere else
 * `tob` is just today's date and the number would be confidently wrong.
 */
const getBirthNumberFor = (startsWithMode, tob, tz) => {
    if (startsWithMode !== 'auto' || !tob || !tz) {
        return null;
    }
    try {
        const date = dayjs_1.default.tz(tob, tz);
        return date.isValid() ? (0, numerology_1.getBirthNumber)(date.date()) : null;
    }
    catch {
        return null;
    }
};
exports.getBirthNumberFor = getBirthNumberFor;
const parseNameNumbers = (value) => {
    if (!value) {
        return undefined;
    }
    const numbers = [
        ...new Set(value
            .split(',')
            .map((item) => Number(item.trim()))
            .filter((item) => numerology_1.NAME_NUMBERS.includes(item))),
    ].sort((a, b) => a - b);
    return numbers.length ? numbers : undefined;
};
const getStateFromParams = (params) => {
    const panjangam = params.get('panjangam');
    const numerology = params.get('numerology');
    const base = {
        gender: params.get('gender') || undefined,
        twinNames: params.get('twinNames') === 'true',
        religion: params.get('religion') || undefined,
        tob: params.get('tob') || (0, dayjs_1.default)().format('YYYY-MM-DDTHH:mm'),
        tz: params.get('tz') || (0, timezones_1.getDefaultTimezone)(),
        // Anything unknown (or not implemented yet) falls back to the default,
        // so an unsupported method can never reach the calculation.
        panjangam: panjangam && (0, astro_1.isImplementedPanjangam)(panjangam)
            ? panjangam
            : astro_1.DEFAULT_PANJANGAM,
        numerology: numerology && (0, numerology_1.isImplementedNumerology)(numerology)
            ? numerology
            : numerology_1.DEFAULT_NUMEROLOGY,
        nameNumbers: parseNameNumbers(params.get('nameNumbers')),
    };
    const startsWithMode = params.get('startsWithMode') ||
        'none';
    if (startsWithMode === 'manual') {
        return {
            ...base,
            startsWithMode,
            startsWith: params.get('startsWith')?.split(',') || [],
        };
    }
    return { ...base, startsWithMode };
};
exports.getStateFromParams = getStateFromParams;
const getDocumentTitleByFilter = (filter) => {
    const documentTitle = [];
    if (filter.twinNames) {
        if (filter.gender) {
            if (filter.religion) {
                documentTitle.push(`Twin Names for ${(0, exports.sentenseCase)(filter.religion)} ${(0, exports.sentenseCase)(filter.gender)}s`);
            }
            else {
                documentTitle.push(`Twin Names for ${(0, exports.sentenseCase)(filter.gender)}s`);
            }
        }
        else if (filter.religion) {
            documentTitle.push(`${(0, exports.sentenseCase)(filter.religion)} Names`);
        }
        else {
            documentTitle.push('Twin Names');
        }
    }
    else {
        if (filter.gender) {
            if (filter.religion) {
                documentTitle.push(`${(0, exports.sentenseCase)(filter.religion)} ${(0, exports.sentenseCase)(filter.gender)} Names`);
            }
            else {
                documentTitle.push(`${(0, exports.sentenseCase)(filter.gender)} Names`);
            }
        }
        else if (filter.religion) {
            documentTitle.push(`${(0, exports.sentenseCase)(filter.religion)} Names`);
        }
    }
    if (filter.startsWithMode === 'manual' &&
        filter.startsWith &&
        filter.startsWith.length > 0) {
        documentTitle.push(`Starting with ${filter.startsWith}`);
    }
    else if (filter.startsWithMode === 'auto') {
        const date = (0, exports.getBirthDate)(filter.tob, filter.tz);
        if (date) {
            const lunarMansionIndex = (0, astro_1.getLunarMansionIndex)(date, filter.panjangam);
            const lunarMansion = (0, astro_1.getLunarMansion)(lunarMansionIndex, 'en');
            documentTitle.push(`For ${lunarMansion} Nakshatra`);
        }
    }
    documentTitle.push('Tamil Baby Names');
    return documentTitle.join(' | ');
};
exports.getDocumentTitleByFilter = getDocumentTitleByFilter;
//# sourceMappingURL=index.js.map